<template>
  <Layout style="background: #21343b">
    <h2 v-html="this.title" slot="title" class="text-center" style="color: white" v-if="!isChkLoading"></h2>
    <h4
      v-html="this.content"
      slot="title"
      class="text-center mt-4"
      style="color: white"
      v-if="!isChkLoading && !isLinkWithSignin"
    ></h4>
    <v-form
      slot="content"
      ref="signInForm"
      class="sign text-center mt-8"
      @submit.prevent="setSignIn"
      lazy-validation
      v-if="!isChkLoading"
    >
      <div v-if="verifiedState === State.NotVerified">
        <v-row v-if="isLinkWithSignin" align="center" justify="center">
          <v-col cols="12" class="" align-self="center" align="center">
            <v-avatar
              :color="userInfo.userDisplayName || userInfo.userFullName | iconBackground"
              class="logo"
              round
              size="80"
              style="cursor: pointer"
            >
              <span
                v-if="!userInfo.userPicture"
                style="color: #ffffff; font-size: 25px; text-align: center; font-weight: bold"
              >
                {{ userInfo.userDisplayName || userInfo.userFullName | iconFilter }}
              </span>
              <v-img :src="userInfo.userPicture" v-else />
            </v-avatar>
          </v-col>
          <v-col cols="12" class="mb-10" align-self="center" align="center">
            <span style="color: #eee; font-size: 18px">{{ 'Signing up as ' }}{{ userInfo.userDisplayName }}</span>
          </v-col>
        </v-row>
        <v-btn
          block
          outlined
          elevation="0"
          height="40"
          id="signInWithGoogle"
          color="white"
          class="google"
          @click="setSignInWithGoogle"
        >
          <span class="icon mr-4" />
          {{ $t('signInWithGoogle') }}
        </v-btn>
        <v-divider class="mt-6 mb-4" color="#666666" />
        <v-container class="pl-0 pr-0">
          <v-row>
            <v-col class="pt-0 pb-0 text-left">
              <label for="email" class="text-left" style="color: white">{{ $t('email') }}</label>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pt-0 pb-0">
              <v-text-field
                outlined
                dense
                ref="email"
                id="email"
                dark
                class="text-field"
                :placeholder="$t('msgEnterEmail')"
                hide-details="auto"
                :rules="[rules.required(email, 'email'), rules.email]"
                v-model="email"
                @keyup="checkVal(0, $refs.email.hasError)"
                @blur="checkVal(0, $refs.email.hasError)"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pt-0 pb-0 mt-5">
              <v-btn
                type="submit"
                block
                elevation="0"
                height="40"
                :disabled="!isBtnAble || isLoading"
                :loading="isLoading"
                :class="'btn-' + (isBtnAble ? 'able' : 'disable')"
                id="continueWithEmail"
                @click="setVerifyCode"
              >
                {{ $t('continue') }}
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pt-0 pb-0 mt-5">
              <v-alert dense style="background-color: transparent; color: #96a7af; font-size: 12px; padding: 0">
                <span v-html="$t('policyText')" />
              </v-alert>
            </v-col>
          </v-row>
          <v-row v-if="showMsg">
            <v-col class="pt-0 pb-0 mt-5">
              <v-alert dense outlined dark>
                <span v-html="errorMessage" />
                <!-- <span v-if="errorCode === 'auth/user-not-found' || errorCode === 'auth/wrong-password'">
                <router-link :to="{ name: 'SignUp', params: { passedEmail: this.email } }">
                  {{ $t('goSignUp') }}
                </router-link>
                {{ $t('or') }}
                <a @click="resetPassword()">{{ $t('resetPassword') }}</a>
              </span> -->
              </v-alert>
            </v-col>
          </v-row>
        </v-container>
      </div>

      <!-- 인증중 화면 -->
      <div v-else-if="verifiedState === State.InProgress">
        <v-container class="pl-0 pr-0">
          <v-row>
            <v-col class="pt-0 pb-0 text-left">
              <label for="email" class="text-left" style="color: white">{{ $t('signInVerifyLabel') }}</label>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pt-0 pb-0">
              <v-text-field
                outlined
                dense
                ref="verifyCode"
                id="verifyCode"
                dark
                class="text-field"
                :placeholder="$t('signInVerifyHint')"
                hide-details="auto"
                :rules="[rules.verifyRequired(verifyCode, 'verifyCode'), rules.verifyCode]"
                v-model="verifyCode"
                @keyup="checkVal(0, $refs.verifyCode.hasError)"
                @blur="checkVal(0, $refs.verifyCode.hasError)"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pt-0 pb-0 mt-5">
              <v-btn
                type="submit"
                block
                elevation="0"
                height="40"
                :disabled="!isBtnAble || isFirstTyped || isInprogressLoading"
                :loading="isInprogressLoading"
                :class="'btn-' + (isBtnAble && !isFirstTyped ? 'able' : 'disable')"
                id="continueWithEmail"
                @click="checkVerifyWithFirebase"
              >
                {{ $t('continue') }}
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pt-0 pb-0 mt-5">
              <v-alert dense style="background-color: transparent; color: #96a7af; font-size: 12px; padding: 0">
                <span v-html="$t('policyText')" />
              </v-alert>
            </v-col>
          </v-row>
          <v-row v-if="showMsg">
            <v-col class="pt-0 pb-0 mt-5">
              <v-alert dense outlined dark>
                <span v-html="errorMessage" />
                <!-- <span v-if="errorCode === 'auth/user-not-found' || errorCode === 'auth/wrong-password'">
                <router-link :to="{ name: 'SignUp', params: { passedEmail: this.email } }">
                  {{ $t('goSignUp') }}
                </router-link>
                {{ $t('or') }}
                <a @click="resetPassword()">{{ $t('resetPassword') }}</a>
              </span> -->
              </v-alert>
            </v-col>
          </v-row>
        </v-container>
      </div>

      <!-- 인증 끝난 화면 -->
      <div v-else-if="verifiedState === State.Verified">
        <!-- <div> -->
        <v-container class="pl-0 pr-0">
          <v-row align="center" justify="center">
            <v-col cols="12" class="" align-self="center" align="center">
              <v-avatar
                :color="userFullName || 'A' | iconBackground"
                class="logo"
                round
                size="80"
                style="cursor: pointer"
                @click="$refs.uploader.click()"
              >
                <span
                  v-if="!userPicture"
                  style="color: #ffffff; font-size: 25px; text-align: center; font-weight: bold"
                >
                  {{ userFullName || 'A' | iconFilter }}
                </span>
                <v-img :src="userPicture" v-else />
              </v-avatar>
            </v-col>
            <!-- <v-col cols="12" class="mb-10" align-self="center" align="center">
              <span style="color: #eee; font-size: 18px">{{ 'As ' }}{{ userInfo.userDisplayName }}</span>
            </v-col> -->
            <v-row no-gutters class="upload" justify="center" align="center">
              <label for="upload" style="color: white; font-weight: 500">{{ $t('uploadProfilePicture') }}</label>
              <input ref="uploader" accept=".png,.jpg,.jpeg" type="file" id="upload" @change="setUserPicture" />
            </v-row>
            <v-col cols="12">
              <span class="txt-picture-comment">Recommanded size is 280 x 280 pixels</span>
            </v-col>
            <v-col v-if="userPicture" class="txt-picture-delete" cols="12">
              <u><span @click="userPicture = null" style="cursor: pointer">Remove current image</span></u>
            </v-col>
          </v-row>
          <v-row class="mt-10">
            <v-col class="pt-0 pb-0 text-left">
              <label for="email" class="text-left" style="color: white">{{ $t('signInVerifiedLabel') }}</label>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pt-0 pb-0">
              <v-text-field
                outlined
                dense
                dark
                ref="userFullName"
                id="userFullName"
                class="text-field"
                :placeholder="$t('msgEnterUserFullName')"
                hide-details="auto"
                :rules="[rules.required(userFullName, 'userFullName')]"
                validate-on-blur
                v-model="userFullName"
                @keyup="checkVal(0, $refs.userFullName.hasError)"
                @blur="checkVal(0, $refs.userFullName.hasError)"
              />
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pt-0 pb-0 mt-5">
              <v-btn
                type="submit"
                block
                elevation="0"
                height="40"
                :disabled="!isBtnAble || isVerifiedLoading"
                :loading="isVerifiedLoading"
                :class="'btn-' + (isBtnAble ? 'able' : 'disable')"
                id="continueWithEmail"
                @click="setSignUp"
              >
                {{ $t('finish') }}
              </v-btn>
            </v-col>
          </v-row>
          <v-row>
            <v-col class="pt-0 pb-0 mt-5">
              <v-alert dense style="background-color: transparent; color: #96a7af; font-size: 12px; padding: 0">
                <span v-html="$t('policyText')" />
              </v-alert>
            </v-col>
          </v-row>
          <v-row v-if="showMsg">
            <v-col class="pt-0 pb-0 mt-5">
              <v-alert dense outlined dark>
                <span v-html="errorMessage" />
                <!-- <span v-if="errorCode === 'auth/user-not-found' || errorCode === 'auth/wrong-password'">
                <router-link :to="{ name: 'SignUp', params: { passedEmail: this.email } }">
                  {{ $t('goSignUp') }}
                </router-link>
                {{ $t('or') }}
                <a @click="resetPassword()">{{ $t('resetPassword') }}</a>
              </span> -->
              </v-alert>
            </v-col>
          </v-row>
        </v-container>
      </div>
    </v-form>
  </Layout>
</template>

<script>
import Layout from '@/layouts/Onboarding'
import { fill } from 'lodash'
import { isNull, regExpTest } from '@/common/lib/strLib'
import firebase from 'firebase/app'
import Toast from '@/views/meeting/component/Toast'
import {
  setUserFunnel,
  setVerifyCode,
  checkVerifyWithFirebase,
  setFileUpload,
  setInvalidCache,
  setCreateWs,
  setUserUpdate,
} from '@/services/api'
import { mapState, mapGetters } from 'vuex'

/**
 * Email 인증 상태
 */
const State = Object.freeze({
  NotVerified: 'notVerified',
  InProgress: 'inProgress',
  Verified: 'verified',
})

export default {
  name: 'SignIn',
  components: {
    Layout,
  },
  async created() {
    // 게스트 로그인일 경우 회원가입 로직 분기처리
    this.$store.dispatch('setFirebaseLog', {
      eventName: 'screen_view',
      eventParam: {
        firebase_screen: '로그인',
        firebase_screen_class: 'SignIn',
      },
    })

    this.valChkArray = fill(Array(1), false)
    // TODO: 워크스페이스 초대 링크를 통해 들어온 경우 가입 완료 시 바로 워크스페이스로 redirect 될 수 있도록
  },
  data: () => ({
    email: '',
    // password: '',
    showOthers: false,
    valChkArray: [],
    isBtnAble: false,
    isLoading: false,
    isInprogressLoading: false,
    isVerifiedLoading: false,
    showMsg: false,
    errorCode: '',
    errorMessage: '',
    policy: '',
    State,
    verifyCode: null,
    verifiedState: State.NotVerified,
    userFullName: '',
    userPicture: null,
    loginResult: null,
    isFirstTyped: true,
  }),
  computed: {
    ...mapGetters(['chkMtPublic']),
    ...mapState({
      userInfo: (state) => {
        return state.auth.userInfo
      },
    }),
    isChkLoading() {
      if (this.userInfo && this.userInfo.userStatus !== 'G') {
        return true
      } else return this.$store.getters.chk_isLoading
    },
    rules() {
      let vm = this

      return {
        required: (value, type) => !isNull(value) || vm.$t('msgEnter' + type.charAt(0).toUpperCase() + type.slice(1)),
        verifyRequired: (value, type) =>
          !isNull(value) || this.isFirstTyped || vm.$t('msgEnter' + type.charAt(0).toUpperCase() + type.slice(1)),
        email: (value) => regExpTest('EMAIL', value) || vm.$t('msgCheckEmailFormat'),
        verifyCode: (value) => {
          if (!isNull(value)) return value.length === 6 || vm.$t('msgCheckVerifyFormat')
          else return true
        },
      }
    },
    isLinkWithSignin() {
      return this.userInfo && this.userInfo.userStatus === 'G'
    },
    title() {
      let title = ''
      if (this.verifiedState === this.State.NotVerified) title = this.$t('signInTitle')
      else if (this.verifiedState === this.State.InProgress) title = this.$t('signInVerifyTitle')
      else if (this.verifiedState === this.State.Verified) title = this.$t('signInVerifiedTitle')
      return title
    },
    content() {
      let content = ''
      if (this.verifiedState === this.State.NotVerified) content = this.$t('signInContent')
      else if (this.verifiedState === this.State.InProgress) content = this.$t('signInVerifyContent')
      else if (this.verifiedState === this.State.Verified) content = this.$t('signInVerifiedContent')
      return content
    },
  },
  watch: {
    verifyCode() {
      this.isFirstTyped = false
    },
  },
  methods: {
    // 회원가입, 게스트 로그인 시 워크스페이스 자동 생성
    async setAutoCreateWs(userName) {
      let wsName = userName.toLowerCase().charAt(userName.length - 1) === 's' ? `${userName}'` : `${userName}'s`
      await setCreateWs(this, `${wsName} Workspace`, userName, 'default')
    },
    async resetPassword() {
      // notify(this, 'Success', this.$t('sendResetPassWord'), 'success')
      const content = {
        component: Toast,
        props: {
          msg: this.$t('sendResetPassWord'),
          // submsg: '',
        },
      }
      this.$toast.success(content)
      await firebase.auth().sendPasswordResetEmail(this.email)
    },
    checkVal(index, result) {
      this.valChkArray.splice(index, 1, !result)
      this.isBtnAble = !this.valChkArray.includes(false)
    },
    async setSignInWithGoogle() {
      this.isLoading = true
      this.errorCode = ''
      this.errorMessage = ''
      this.showMsg = false

      try {
        let provider = new firebase.auth.GoogleAuthProvider()
        let result

        // 게스트 로그인시 Google 로그인 계정과 게스트 계정을 연동해준다.
        if (this.isLinkWithSignin) {
          await firebase.auth().currentUser.getIdToken(true)
          result = await firebase.auth().currentUser.linkWithPopup(provider)

          const signedInEmail = this.userInfo['userEmail']
          const resultEmail = result['additionalUserInfo']['profile']['email']

          // 기존 게스트 로그인한 Email 주소와 구글 메일 주소가 다를 경우 Link 연결 해제
          if (signedInEmail !== resultEmail) {
            await firebase.auth().currentUser.unlink(provider.providerId)
            // notify(this, 'Error', `${this.$t('linkWithGoogleError')}<br/>${signedInEmail}`, 'error')
            const content = {
              component: Toast,
              props: {
                msg: `${this.$t('linkWithGoogleError')}<br/>${signedInEmail}`,
                // submsg: '',
              },
            }
            this.$toast.error(content)
            return
          }
        }
        // 일반 구글 로그인일 경우
        else {
          result = await firebase.auth().signInWithPopup(provider)
        }
        this.moveRouter(result, true)
      } catch (error) {
        this.errorCode = error.code
        this.errorMessage =
          this.errorCode === 'auth/user-not-found' || this.errorCode === 'auth/wrong-password'
            ? this.$t('msgSignInFailed')
            : error.message
        this.showMsg = true
        this.isLoading = false
      } finally {
        this.isLoading = false
      }
    },
    // 일반 이메일 회원가입일 경우
    async setSignUpWithEmail() {
      this.errorCode = ''
      this.errorMessage = ''
      this.showMsg = false

      try {
        this.loginResult = await firebase.auth().createUserWithEmailAndPassword(this.email, this.verifyCode)
      } catch (error) {
        if (error.code === 'auth/email-already-in-use') {
          await this.setSignInWithEmail()
          this.verifiedState = State.Verified
        } else {
          this.errorCode = error.code
          this.errorMessage =
            this.errorCode === 'auth/email-already-in-use' ? this.$t('msgEmailAlreadyInUse') : error.message
          this.showMsg = true
        }
      }
    },
    //
    async setSignInWithEmail() {
      this.errorCode = ''
      this.errorMessage = ''
      this.showMsg = false

      try {
        // 게스트 로그인일 경우
        // if (this.isLinkWithSignin) {
        //   await firebase.auth().currentUser.getIdToken(true)

        //   // // Email, Password 로 credential 을 만들어준다.
        //   let emailCredential = firebase.auth.EmailAuthProvider.credential(this.email, this.verifyCode)
        //   // // 익명 계정을 영구 계정으로 전환 해준다.
        //   this.loginResult = await firebase.auth().currentUser.linkWithCredential(emailCredential)
        //   // // Firebase displayName 과 이메일 인증여부를 변경해준다.

        //   this.userInfo['userEmail'] = this.email
        //   // this.loginResult = firebase.auth().currentUser
        //   // console.log('this.loginResult bbb ', this.loginResult)
        // } else {

        this.loginResult = await firebase.auth().signInWithEmailAndPassword(this.email, this.verifyCode)
        // }
      } catch (error) {
        this.errorCode = error.code
        this.errorMessage =
          this.errorCode === 'auth/user-not-found' || this.errorCode === 'auth/wrong-password'
            ? this.$t('msgSignInFailed')
            : error.message
        this.showMsg = true
      }
    },
    setUserPicture(e) {
      // TODO: 모달창으로 설정하도록 변경 필요
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) return
      this.createImage(files[0])
      e.target.value = ''
    },
    createImage(file) {
      var reader = new FileReader()
      reader.onload = async (e) => {
        this.userPicture = await this.resizeImage(e.target.result)
      }
      reader.readAsDataURL(file)
    },
    // TODO: common library로 이동
    resizeImage(base64Str, maxWidth = 160, maxHeight = 160) {
      return new Promise((resolve) => {
        let img = new Image()
        img.src = base64Str
        img.onload = () => {
          let canvas = document.createElement('canvas')
          const MAX_WIDTH = maxWidth
          const MAX_HEIGHT = maxHeight
          let width = img.width
          let height = img.height

          if (width > height) {
            if (width > MAX_WIDTH) {
              height *= MAX_WIDTH / width
              width = MAX_WIDTH
            }
          } else {
            if (height > MAX_HEIGHT) {
              width *= MAX_HEIGHT / height
              height = MAX_HEIGHT
            }
          }
          canvas.width = width
          canvas.height = height
          let ctx = canvas.getContext('2d')
          ctx.drawImage(img, 0, 0, width, height)
          resolve(canvas.toDataURL())
        }
      })
    },
    async uploadUserPicture() {
      // userPicture 업로드
      try {
        let userId = await firebase.auth().currentUser['uid']

        // userPicture S3 업로드
        let parallellUploads = await setFileUpload(this, this.userPicture, 'userPicture', userId)
        parallellUploads.on('httpUploadProgress', () => {
          // console.log('progress ', Math.floor(100 / (progress.total / progress.loaded)))
        })
        // S3 Upload
        await parallellUploads.done()
        // Cloud Front 캐시 삭제
        await setInvalidCache(this, `/userPicture/${userId}.png`)
      } catch (err) {
        this.errorMessage = err
      }
    },
    async setSignUp() {
      this.isVerifiedLoading = true
      this.errorCode = ''
      this.errorMessage = ''
      this.showMsg = false

      try {
        // let result = await setUserUpdate(this, this.userFullName, this.userInfo.userDisplayName)

        await this.loginResult.user.updateProfile({
          displayName: this.userFullName,
        })

        // 회원가입일 경우 Default Workspace를 자동으로 만들어준다.
        await this.setAutoCreateWs(this.userFullName)
      } catch (error) {
        this.errorCode = error.response.status
        this.errorMessage = this.$t('msg' + this.errorCode.charAt(0).toUpperCase() + this.errorCode.slice(1))

        this.showMsg = true
      } finally {
        this.isVerifiedLoading = false
      }

      if (this.errorMessage === undefined || this.errorMessage === null || this.errorMessage === '') {
        if (this.loginResult) await this.moveRouter(this.loginResult, false)
      }
    },
    async moveRouter(userResult, isGoogleSignup) {
      this.$store.dispatch('setIsLoading', true)

      try {
        // 현재 유저 설정
        await this.$store.dispatch('setCurrentUser', userResult.user)
        // api header Authorization 설정
        await this.$store.dispatch('setApiHeader')

        // Google Login Routing 처리
        if (isGoogleSignup) {
          // 소셜 로그인 최초 로그인
          if (userResult.user !== null && userResult.additionalUserInfo.isNewUser) {
            // 최초 로그인이면 가입
            await this.$store.dispatch('setSignUp', {
              userFullName: '',
              userDisplayName: userResult.user.displayName,
              deviceToken: '',
            })
            this.$store.dispatch('setFirebaseLog', {
              eventName: 'signup_with_google',
              eventParam: {
                name: 'signup_with_google',
                methodType: this.chkMtPublic['isPublic'] ? 'share_link' : 'normal',
                userStatus: 'C',
              },
            })

            // 회원가입일 경우 Default Workspace를 자동으로 만들어준다.
            await this.setAutoCreateWs(
              this.userInfo && this.userInfo['userDisplayName']
                ? this.userInfo['userDisplayName']
                : userResult.user.displayName
            )
          } else {
            try {
              let signInResult = await this.$store.dispatch('setSignIn', {
                deviceToken: '',
                isLinkWithSignin: true,
              })
              // 게스트 로그인을 했지만 Email 주소를 입력 안했을 경우
              if (this.isLinkWithSignin && signInResult && signInResult === 'userNotExist') {
                // 최초 로그인이면 가입
                await this.$store.dispatch('setSignUp', {
                  userFullName: '',
                  userDisplayName: userResult.user.displayName,
                  deviceToken: '',
                })
                this.$store.dispatch('setFirebaseLog', {
                  eventName: 'signup_with_google',
                  eventParam: {
                    name: 'signup_with_google',
                    methodType: this.chkMtPublic['isPublic'] ? 'share_link' : 'normal',
                    userStatus: 'C',
                  },
                })

                // 회원가입일 경우 Default Workspace를 자동으로 만들어준다.
                await this.setAutoCreateWs(
                  this.userInfo && this.userInfo['userDisplayName']
                    ? this.userInfo['userDisplayName']
                    : userResult.user.displayName
                )
              }
            } catch (error) {
              console.log()
            }
            this.$store.dispatch('setFirebaseLog', {
              eventName: 'signin_with_google',
              eventParam: {
                name: 'signin_with_google',
                methodType: this.chkMtPublic['isPublic'] ? 'share_link' : 'normal',
                userStatus: 'C',
              },
            })
          }
        }
        // Email Login Routing 처리
        else {
          // 게스트로 로그인 시
          if (this.isLinkWithSignin) {
            // Firebase 정보를 업데이트 해준다.
            await firebase.auth().currentUser.updateProfile({
              email: this.email,
              displayName: this.userInfo['userDisplayName'],
            })
            // 회원 DB에 email, userName 을 업데이트 해준다.
            await setUserUpdate(this, this.userFullName, this.userInfo.userDisplayName)

            // 바뀐 정보로 로그인을 시켜준다. (userState G -> C 로 변경)
            await this.$store.dispatch('setSignIn', {
              deviceToken: '',
              isLinkWithSignin: true,
            })
          }
          // 회원가입 진행 시
          else if (this.verifiedState === State.Verified) {
            await this.$store.dispatch('setSignUp', {
              userFullName: this.userFullName,
              userDisplayName: this.userFullName,
              deviceToken: '',
            })
            this.$store.dispatch('setFirebaseLog', {
              eventName: 'signup_with_email',
              eventParam: {
                name: 'signup_with_email',
                methodType: this.chkMtPublic['isPublic'] ? 'share_link' : 'normal',
              },
            })
          }
          // 일반 로그인 시
          else {
            await this.$store.dispatch('setSignIn', {
              deviceToken: '',
            })
            this.$store.dispatch('setFirebaseLog', {
              eventName: 'signin_with_email',
              eventParam: {
                name: 'signin_with_email',
                methodType: this.chkMtPublic['isPublic'] ? 'share_link' : 'normal',
              },
            })
          }
          // 프로필 사진이 있다면 업로드
          if (this.userPicture) await this.uploadUserPicture()
        }

        if (this.userInfo && this.userInfo !== null) {
          await this.checkFunnel(isGoogleSignup ? 'signup_with_google' : 'signup_with_email')

          // 참여 워크스페이스가 없으면, 워크스페이스 생성/참여 페이지로 이동
          await this.$store.dispatch('getUserWsList')

          // if (location.pathname.includes('share')) {
          if (this.$store.getters.signInRedirectUrl && this.$store.getters.signInRedirectUrl !== null) {
            let signInRedirectUrl = this.$store.getters.signInRedirectUrl
            await this.$store.dispatch('setSignInRedirectUrl', null)
            this.$router.push(signInRedirectUrl).catch(() => {})
          } else {
            if (this.$store.getters.userWsList.length === 0) this.$router.replace({ name: 'Workspace' }).catch(() => {})
            else {
              this.$router.replace(`${this.$store.getters.userWsList[0].wsDomain}/my`).catch(() => {})
            }
          }
        }
      } catch (error) {
        this.$store.dispatch('setIsLoading', false)
      }
    },
    // Email 인증코드 전송
    async setVerifyCode() {
      this.isLoading = true

      // if (!this.$refs.signInForm.validate()) return false

      try {
        this.verifiedState =
          (await setVerifyCode(this, this.email, 'signIn', this.isLinkWithSignin)) === 'success'
            ? State.InProgress
            : State.NotVerified
      } catch (error) {
        if (error.response.data === 'userExist') {
          // notify(this, 'Error', this.$t('msgEmailAlreadyInUse'), 'error')
          const content = {
            component: Toast,
            props: {
              msg: this.$t('msgEmailAlreadyInUse'),
              // submsg: '',
            },
          }
          this.$toast.error(content)
        }
      } finally {
        this.isLoading = false
      }
    },
    // Email 인증코드 확인
    async checkVerifyWithFirebase() {
      this.isInprogressLoading = true
      try {
        let result = await checkVerifyWithFirebase(
          this,
          this.userInfo ? this.userInfo['userId'] : undefined,
          this.email,
          'signIn',
          this.verifyCode,
          1
        )
        if (result) {
          // 유저정보가 없다면 회원가입 진행
          if (result['isSignUp']) {
            await this.setSignUpWithEmail()
            this.verifiedState = result['isSuccess'] ? State.Verified : State.InProgress
          }
          // 유저정보가 있다면 다음 프로세스 진행
          else {
            await this.setSignInWithEmail()
            this.moveRouter(this.loginResult, false)
          }
        }
      } catch (error) {
        if (error.response.data === 'incorrectCode') {
          // notify(this, 'Error', this.$t('msgIncorrectCode'), 'error')
          const content = {
            component: Toast,
            props: {
              msg: this.$t('msgIncorrectCode'),
              // submsg: '',
            },
          }
          this.$toast.error(content)
        }
      } finally {
        this.isInprogressLoading = false
      }
    },
    async checkFunnel(signupType) {
      try {
        const funnel = this.userInfo.funnel
        if (!funnel || funnel === '') {
          let result = await setUserFunnel(this, 'evaluator')
          this.$store.commit('setUserInfo', result)

          this.$store.dispatch('setFirebaseLog', {
            eventName: 'funnel_evaluator',
            eventParam: {
              createdAt: Date.now(),
              methodType: signupType,
            },
          })
        }
      } catch (e) {
        console.log()
      }
    },
  },
}
</script>
<style scoped>
.upload label {
  display: inline;
  border-bottom: 1px solid transparent;
  cursor: pointer;
}

.upload label:hover {
  border-bottom: 1px solid #666;
}

.upload input {
  width: 0;
  height: 0;
  line-height: 0;
  font-size: 0;
  text-indent: -9999px;
}

.upload img {
  display: block;
  width: calc(100% - 2px) !important;
  height: calc(100% - 2px) !important;
  object-fit: cover;
}

.txt-picture-comment {
  background-color: transparent;
  color: #96a7af;
  font-size: 14px;
  padding: 0;
}
.txt-picture-delete {
  background-color: transparent;
  color: #96a7af;
  font-size: 12px;
  padding: 0;
}
</style>
